/* istanbul ignore file */
export const notNull = (value) => value != null;
//# sourceMappingURL=notNull.js.map